import paths from './vue/router/paths';

const usersConfig = {
    config: [
        { // admin
            userId: +process.env.VUE_APP_ADMIN_ID,
            allowedRoutes: [paths.trips, paths.tripsMap, paths.events, paths.garage, paths.carFleet, paths.geoFences, paths.reports, paths.admin.onBoard, paths.admin.decoder],
            home: paths.admin.onBoard
        },
        { // Oazis
            userId: 255,
            allowedRoutes: [...paths.regularUserAccess, ...[paths.oazisSuppliersMap]]
        },
        { // nachev
            userId: 133,
            allowedRoutes: [...paths.regularUserAccess, ...paths.adminWall]
        },
        { // nikolay tashev
            userId: 217,
            allowedRoutes: [...paths.regularUserAccess, ...paths.adminWall]
        }
    ],

    getByUserId(userId) {
        let userConfig = this.config.find(item => item.userId === userId);
        if (!userConfig) {
            userConfig = this.config.find(item => item.userId === '*');
        }

        return userConfig;
    },

    isPathAllowed(userId, path) {
        const pathname = path.split(/[?#]/)[0];

        if (pathname === paths.auth) {
            return true;
        }

        let allowedRoutes = paths.regularUserAccess;

        const userConfig = usersConfig.getByUserId(userId);
        if (userConfig && userConfig.allowedRoutes) {
            allowedRoutes = userConfig.allowedRoutes;
        }

        return allowedRoutes.includes(pathname);
    },

    getUserHome(userId) {
        const userConfig = usersConfig.getByUserId(userId);
        if (userConfig && userConfig.home) {
            return userConfig.home;
        }

        return paths.home;
    }
};

export default usersConfig;